<!--
@Create By Tim For 19/08/13
@头部组件
-->
<template>
  <div class="Header">
    <div class="auto">
      <!-- LOGO区域 -->
      <div class="logo"><img src="../../../static/logo.png"/></div>
      <!-- 导航模块 -->
      <div class="nav">
        <el-tabs :key="tabKey" v-model="menu" @tab-click="changePage">
          <el-tab-pane label="首页" name="Home"/>
          <el-tab-pane label="在线课程" name="AllCourse"/>
          <el-tab-pane label="课程资料库" name="DataList"/>
          <el-tab-pane disabled label="试题库" name="tests"/>
          <el-tab-pane label="培训需求" name="Demand"/>
        </el-tabs>
      </div>
      <!-- 登录模块 -->
      <div class="login">
        <ul>
          <li><i class="el-icon-s-comment"></i></li>
          <li v-if="user">{{ $store.state.userName }}</li>
          <span @click="logout" v-if="user" class="logout">退出</span>
          <li v-else @click="openLoginDialog">登录</li>
        </ul>
      </div>
      <!-- 搜索 -->
      <div class="search">
        <el-select class="selects" popper-class="selectsPop" v-model="selectValue"
                   placeholder="请选择">
          <el-option v-for="item in options" :key="item.value" :label="item.label"
                     :value="item.value"></el-option>
        </el-select>
        <el-input class="searchInput" v-model="searchInput" @clear="clear" clearable
                  placeholder="请输入内容"></el-input>
        <el-button class="searchBtn" type="primary" icon="el-icon-search"
                   @click="search"></el-button>
      </div>
    </div>
    <!-- 登录组件 -->
    <Login ref="login"/>
  </div>
</template>
<script>
import Login from '../Login/Login'
import Bus from '../../bus'
import {removeToken, getToken, removeUser, getUser, toLogout} from 'chaos-sso-util'
import api from '../../../config/api'

export default {
  name: 'Header',
  data () {
    return {
      options: [
        {
          value: '1',
          label: '课程'
        },
        {
          value: '2',
          label: '文档'
        }
      ],
      selectValue: '1',
      searchInput: '',
      // 菜单名
      menu: '',
      // 用户信息
      user: '',
      // 刷新导航栏key
      tabKey: null,
      currentMenu: []
    }
  },

  components: {
    Login
  },

  created () {
    // 刷新页面时根据路由定位菜单选中项
    this.menuFix()
    // 监听登录消息
    this.userInfo()
    // 判断是否有用户信息
    this.isLogin()
    // 刷新导航栏
    this.refreshNav()
  },

  methods: {
    // 打开登录窗
    openLoginDialog () {
      this.$refs.login.openDialog()
    },

    // 头部导航跳转
    changePage (data) {
      switch (data.label) {
        case '首页':
          this.$router.push({path: '/'})
          break
        case '在线课程':
          this.$router.push({path: '/AllCourse'})
          break
        case '课程资料库':
          this.$router.push({path: '/DataList'})
          break
        case '培训需求':
          this.$router.push({path: '/Demand'})
          break
      }
    },

    // 刷新页面时根据路由定位菜单选中项
    menuFix () {
      switch (this.$route.name) {
        case 'Home':
          this.menu = 'Home'
          break
        case 'AllCourse':
          this.menu = 'AllCourse'
          break
        case 'CourseInfo':
          this.menu = 'AllCourse'
          break
        case 'DataList':
          this.menu = 'DataList'
          break
        case 'DataInfo':
          this.menu = 'DataList'
          break
        case 'Demand':
          this.menu = 'Demand'
          break
      }
    },

    // 监听登录
    userInfo () {
      Bus.$on('loginSuccess', data => {
        this.user = data.userName
      })
    },

    // 判断是否存在用户信息
    isLogin () {
      let users = getUser()
      if (users) {
        this.user = users.userName
      }
    },

    // 退出
    logout () {
      this.user = null
      this.menu = 'Home'
      const token = getToken()
      this.$axios.get(api + `logout`).then(res => {
        removeUser()
        removeToken()
        toLogout(token)
      })
    },

    // 搜索方法
    search () {
      if (this.selectValue === '1') {
        this.$router.replace({path: '/AllCourse', query: {courseName: this.searchInput}})
      } else if (this.selectValue === '2') {
        this.$router.replace({path: '/DataList', query: {docName: this.searchInput}})
        Bus.$emit('searchDoc', this.searchInput)
      }
    },

    // 搜索框清空时触发
    clear () {
      if (this.selectValue === '1') {
        this.$router.replace({path: '/AllCourse', query: {courseName: this.searchInput}})
      } else if (this.selectValue === '2') {
        this.$router.replace({path: '/DataList', query: {docName: this.searchInput}})
        Bus.$emit('searchDoc', this.searchInput)
      }
    },

    // 刷新导航栏
    refreshNav () {
      Bus.$on('refreshNav', data => {
        this.menu = 'AllCourse'
      })
    }
  }
}
</script>
<style>
.Header .search .selects {
  float: left;
}

.Header .search .selects .el-input__inner {
  width: 80px;
  border-radius: 4px 0 0 4px;
}

.Header .search .searchInput {
  width: 200px;
  float: left;
}

.Header .search .searchInput .el-input__inner {
  width: 200px;
  border-right: none;
  border-radius: 0;
}

.Header .search .searchBtn {
  float: left;
  border-radius: 0 4px 4px 0;
  margin-top: 1px;
}

.Header .el-tabs__nav {
  height: 59px;
}

.Header .el-tabs__item {
  font-size: 16px;
}

.Header .el-tabs__header {
  margin: 0;
}

.Header .el-tabs__nav-wrap::after {
  background: transparent;
}
</style>
<style scoped>
.Header {
  padding: 0 20px;
  min-width: 1440px;
  height: 79px;
  border-bottom: 1px solid #d8d8d8;
}

.Header .auto {
  width: 1440px;
  margin: 0 auto;
  height: 79px;
  background: #fff;
}

.Header .logo {
  width: 211px;
  height: 79px;
  float: left;
  font-size: 24px;
}

.Header .logo img {
  margin-top: 10px;
}

.Header .nav {
  float: left;
  margin-left: 40px;
  margin-top: 20px;
}

.Header .search {
  float: left;
  margin-left: 60px;
  height: 40px;
  line-height: 40px;
  width: 400px;
  margin-top: 20px;
}

.Header .login {
  float: right;
}

.Header .login ul {
  height: 79px;
  line-height: 79px;
  margin: 0;
  padding: 0;
}

.Header .login ul li {
  list-style: none;
  font-size: 16px;
  color: #333333;
  float: left;
  line-height: 80px;
  margin-left: 20px;
  cursor: pointer;
}

.Header .login ul li:hover {
  color: #409eff;
}

.Header .login i {
  color: #adadad;
  font-size: 16px;
}

.Header .loginInput {
  width: 200px;
}

.Header .logout {
  cursor: pointer;
  margin-left: 10px;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/Common/Header.vue